import React from "react";

import "./Card.scss";

export const Card = ({ children, className = "", style = {} }) => (
  <div className={`bpmCard ${className}`} style={style}>
    {children}
  </div>
);
